import { useFieldArray } from "react-hook-form";
import { Plus } from "lucide-react";
import { Button } from "../../../shared/components/ui";
import { StepEditor } from "./StepEditor";
import { CostTypeEnum } from "../../empresa/contracts/labor-budget";

interface StepsEditorProps {
  methods: any;
  disabled?: boolean;
}

export function StepsEditor({ methods, disabled }: StepsEditorProps) {
  const { control } = methods;
  const { fields, append, remove } = useFieldArray({ control, name: "steps" });

  return (
    <div className="mb-10 flex flex-col gap-3">
      {fields.map((step, index) => (
        <StepEditor
          key={step.id}
          index={index}
          methods={methods}
          removeStep={remove}
          disabled={disabled}
        />
      ))}
      <Button
        type="button"
        variant="outline"
        size="sm"
        startIcon={<Plus className="h-4 w-4" />}
        onClick={() => append({ description: "", costType: CostTypeEnum.DIRECT, mediumTerm: 0, itens: [] })}
        disabled={disabled}
        className="self-start"
      >
        Adicionar Etapa
      </Button>
    </div>
  );
}
